<template>
  <t-layout :showNav="false">
    <div class="page-wrap">
      <div class="code-wrapper">
        <van-form validate-first>
          <van-cell-group class="code__wrapper">
            <div class="content">
              <div class="title">输入兑换码领取福袋券</div>
              <van-field class="input-wrap" v-model="code" clearable placeholder="请输入兑换码" />
              <div class="tips">每个兑换码只能兑换一次哦</div>
            </div>

            <div class="btn-wrap">
              <van-button
                class="conmon-btn"
                @click="haddleExchange"
                :loading="loading"
                loading-text="领取中..."
                >确认兑换</van-button
              >
            </div>
          </van-cell-group>
        </van-form>
      </div>

      <!-- <div class="rule-wrap">
        <img src="https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/rule-detail-v3.png" />
      </div> -->
    </div>

    <tabbar :current="1"></tabbar>
  </t-layout>
</template>

<script>
import tabbar from '../components/tabbar/index'
import tPopup from '@/components/popup/index'
import { Field, CellGroup, Form } from 'vant'

const CODE_KEY = 'lottery_exchange_code'

export default {
  name: 'exchangeLotteryView',
  components: {
    tabbar,
    tPopup,
    [Field.name]: Field,
    [CellGroup.name]: CellGroup,
    [Form.name]: Form
  },
  data() {
    return {
      loading: false,
      showCodeToast: true,
      code: ''
    }
  },
  created() {
    const options = this.$route.query
    if (options.token) {
      let token = decodeURIComponent(options.token)
      localStorage.setItem('token', token)
    }

    //读取缓存code
    this.getCode()
  },
  activated() {
    window.scrollTo(0, 0)
    this.$store.commit('setTitle', '福袋券兑换')
  },
  methods: {
    async haddleExchange() {
      let result = await this.$api.user.getUserInfo()
      let data = result.data
      if (data.code == 0) {
        let userInfo = data.data.user_info
        if (userInfo.mobile) {
          this.tapExchange()
        } else {
          this.setCode(this.code)
          this.$eventBus.$emit('haddleLogin')
        }
      } else {
        this.setCode(this.code)
      }
    },

    getCode() {
      const code = localStorage.getItem(CODE_KEY)
      if (!!code) {
        this.code = code
      }
      localStorage.removeItem(CODE_KEY)
    },

    setCode(code) {
      localStorage.setItem(CODE_KEY, code)
    },

    haddleCodeToast() {
      this.showCodeToast = !this.showCodeToast
    },

    tapExchange() {
      if (this.loading) return
      const code = this.code
      if (!code) {
        this.$toast('请输入兑换码')
        return
      }

      this.loading = true

      this.$api.coupon
        .postExchangeCode({ code })
        .then(result => {
          let res = result.data
          if (res.code == 0) {
            this.$toast({
              duration: 3000,
              message: '领取成功，快去领取彩票吧～'
            })

            const { ver_no } = this.$route.query
            let query_str = ''
            if (ver_no) {
              query_str = `?selected=0&ver_no=${ver_no}`
            } else {
              query_str = `?selected=0`
            }

            this.$router.replace('/lottery/shop' + query_str)
            setTimeout(() => {
              this.code = ''
              this.showCodeToast = false
            }, 300)
          } else {
            this.$toast({
              duration: 3000,
              message: res.msg || '未知错误'
            })
          }

          this.loading = false
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>
<style></style>
<style lang="less" scoped>
.page-wrap {
  padding: 28rpx 24rpx 200rpx;
}
.code-wrapper {
  width: 100%;
  // height: 910rpx;
  height: 1216rpx;
  background-image: url('https://wz-s1.makingdreams101.cn/wanzhuan_mp/h5/lottery/form-bg-v3.png');
  background-position: 0 0;
  background-repeat: no-repeat;
  background-size: 100% 100%;
  // padding: 482rpx 24rpx 28rpx;
  padding: 546rpx 24rpx 28rpx;

  .van-cell::after {
    display: none !important;
  }
  .code__wrapper {
    background: none;

    .content {
      padding: 48rpx 32rpx 32rpx;
      border-radius: 28rpx;
      background: #fff;
      box-shadow: 0 0 16px 0 #fef0a06b;
      // margin-bottom: 28rpx;
      margin-bottom: 32rpx;
    }

    .title {
      text-align: center;
      font-size: 34rpx;
      line-height: 34rpx;
      letter-spacing: 2rpx;
      font-weight: 500;
      margin-bottom: 48rpx;
    }

    .input-wrap {
      width: 100%;
      height: 80rpx;
      margin-bottom: 24rpx;
      background: #f5f5f5;
      display: flex;
      align-items: center;
      border-radius: 12rpx;

      .input {
        flex: 1;
        display: block;
        width: 100%;
        height: 100%;
        padding-left: 32rpx;
        font-size: 26rpx;
      }
    }

    .tips {
      font-size: 26rpx;
      line-height: 26rpx;
      color: #9b9b9b;
      text-align: center;
    }
  }

  .btn-wrap {
    // padding: 0 56rpx;
    padding: 0 52rpx;

    button {
      border: none !important;

      &::before {
        display: none;
      }
    }

    .conmon-btn {
      width: 100%;
      // height: 80rpx;
      // border-radius: 40rpx;
      height: 96rpx;
      border-radius: 48rpx;
      background: #ff3e35;
      text-align: center;
      line-height: 80rpx;
      color: #ffffff;
      // font-size: 30rpx;
      font-size: 34rpx;
      letter-spacing: 2rpx;

      &.disabled {
        opacity: 0.5;
      }
    }
  }
}
.rule-wrap {
  margin-top: 32rpx;

  img {
    display: block;
    width: 100%;
    height: auto;
  }
}

.van-hairline--top-bottom::after {
  display: none;
}
</style>
